import { PrintTemplate } from '../../../../models/print';
import { sendAsync } from '../../../../app/applicationSlice';
import * as S from '../../../../services/print';
import { TreatmentBuilder } from '../builder/TreatmentBuilder';
import { store } from '../../../../app/store';

declare global {
  interface Window {
    LODOP: any;
  }
}

const executeLodopPrint = (commands: string) => {
  if (window.LODOP) {
    try {
      console.log('执行 LODOP 命令:', commands.substring(0, 500) + (commands.length > 500 ? '...' : ''));
      eval(commands);
      return true;
    } catch (error) {
      console.error('LODOP 打印执行失败:', error);
      console.error('失败的命令:', commands.substring(0, 1000) + (commands.length > 1000 ? '...' : ''));
      return false;
    }
  } else {
    console.error('LODOP 未加载');
    return false;
  }
};

const isCompatibleMode = (response: any): boolean => {
  if (typeof response === 'string') {
    const trimmed = response.trim();
    return trimmed.startsWith('LODOP.') || trimmed.startsWith('LODOP ');
  }
  return false;
};

export interface TreatmentData {
  patientId: string;
  feeCategory: string;
  marital: string;
  setupFlag?: boolean;
  preview?: boolean;
  authorizedName?: string;
  authorizedcode?: string;
  [key: string]: any;
}

export class TreatmentParser {
  static parse(jsonResponse: any): TreatmentData {
    try {
      console.log('原始响应数据:', jsonResponse);

      const parsedResponse = typeof jsonResponse === 'string' ? JSON.parse(jsonResponse) : jsonResponse;
      console.log('解析后的响应:', parsedResponse);

      const dataString = parsedResponse?.data;
      console.log('data 字段:', dataString);

      const data = dataString !== undefined
        ? (typeof dataString === 'string' ? JSON.parse(dataString) : dataString)
        : parsedResponse;
      console.log('解析后的 data:', data);

      const result: TreatmentData = {
        ...data,
        treatmentRecord: data?.treatmentRecord || data?.patientInfo || {},
        patient: data?.patient || data?.patientInfo || {},
        addressList: data?.addressList || [],
        patientId: data?.patientId || data?.patient?.id || data?.treatmentRecord?.patientId || '',
        feeCategory: data?.feeCategory || '',
        marital: data?.marital || data?.patient?.maritalStatus || '',
        setupFlag: data?.setupFlag,
        preview: data?.preview,
        authorizedName: data?.authorizedName,
        authorizedcode: data?.authorizedcode,
        compatibleMode: data?.compatibleMode
      };

      console.log('最终返回的数据:', result);
      return result;
    } catch (error) {
      console.error('JSON 解析失败:', error);
      return {} as TreatmentData;
    }
  }

  static async print(template: PrintTemplate, status?: any) {
    try {
      console.log('开始高级打印，模板:', template);
      console.log('状态参数:', status);
      const result = await (async (params: any, api: any) => {
        const param = {
          templateCode: 'Treatment',
          leftOffset: 0,
          topOffset: 0,
          registrationId: status?.registrationId,
          treatmentId: status?.treatmentId,
          recipeId: status?.recipeId,
          paymentId: status?.paymentId,
          branchId: status?.branchId,
          preview: status?.preview,
          printer: status?.printer,
          invoiceId: status?.invoiceId,
          tenantInventoryReceiptsId: status?.tenantInventoryReceiptsId,
          priceTagPrintsIdList: status?.priceTagPrintsIdList,
          startTime: status?.startTime,
          endTime: status?.endTime,
          patientId: status?.patientId,
          templateId: status?.templateId,
          pageName: status?.pageName,
        };

        // ✅ sendAsync 传够 2 个参数，不报错
        const res = await sendAsync(S.getPrintSource(param), api);

        //TODO 不再这里判断兼容模式。判断前置
        if (isCompatibleMode(res)) {
          console.log('检测到兼容模式，直接执行 LODOP 文本');
          return executeLodopPrint(res);
        }

        const data = TreatmentParser.parse(res);
        const lodopCommands = TreatmentBuilder.buildCommands(data, template);
        return executeLodopPrint(lodopCommands);
      })(
        // 第一个参数给 sendAsync 用（可空）
        {},
        // 第二个参数：给 sendAsync 提供 dispatch + getState
        { dispatch: store.dispatch, getState: store.getState }
      );

      return result;
    } catch (error) {
      console.error('打印失败:', error);
      return false;
    }
  }
}